<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1><i class="fa fa-dashboard"></i> {{ $t('reportClient') }}</h1>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><router-link to="/report/client">{{ $t('reportClient') }}</router-link></li>
      </ul>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tabIndex">
          <b-tab>
            <template #title>
              {{ $t('overview') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('byCategory') }}
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <client v-if="tabIndex === 0"></client>
    <client-by-category v-if="tabIndex === 1"></client-by-category>
  </main>
</template>

<script>
import Client from './Client.vue'
import ClientByCategory from './ClientByCategory.vue'

export default {
  components: {Client, ClientByCategory},
  data() {
    return {
      tabIndex: 0,
    }
  },
  i18n: {
    messages: {
      en: {
        reportClient: 'Client report',
        overview: 'Overview',
        byCategory: 'By category',
      },
      vi: {
        reportClient: 'Báo cáo khách hàng',
        overview: 'Tổng quan',
        byCategory: 'Theo ngành',
      }
    }
  },
}
</script>